<template>
  <div>
    <HeaderComponentPackage
      :apiUrl="getApiUrl"
      :themeColor="getThemeColor"
      :secondaryColor="getSecondaryColor"
      :routes="menu"
      :authenticated="getAuthenticated"
      :companyObj="getUserCompany"
      logoRoute="/auth/get-logos-for-given-school"
      @signedOut="signedOut"
    ></HeaderComponentPackage>
  </div>
</template>

<script>
import HeaderComponentPackage from "baron-vue-header-frontend";
import { mapGetters } from "vuex";

export default {
  components: { HeaderComponentPackage },
  computed: mapGetters([
    "getApiUrl",
    "getThemeColor",
    "getAuthenticated",
    "getUserCompany",
    "getSecondaryColor",
  ]),
  data: () => ({
    menu: [
      {
        icon: "mdi-home",
        title: "Home",
        color: "deep-orange darken-4",
        route: "home",
        buttonText: "Enter",
        alevel: 1,
        param: "",
      },

      {
        icon: "apps",
        title: "Switchboard",
        color: "deep-orange darken-4",
        route: "switchboard",
        buttonText: "Enter",
        alevel: 1,
        param: "",
      },
      // {
      //   icon: "mdi-play-box-multiple",
      //   title: "Gallery",
      //   color: "deep-orange darken-4",
      //   route: "images-gallery",
      //   buttonText: "Enter",
      //   alevel: 1,
      //   param: "",
      // },
      {
        icon: "assignment_ind",
        title: "Sign In",
        color: "deep-orange darken-4",
        route: "login",
        buttonText: "Enter",
        alevel: 1,
        param: "",
      },
      {
        icon: "person_add",
        title: "Create Account",
        color: "deep-orange darken-4",
        route: "register",
        buttonText: "Enter",
        alevel: 1,
        param: "",
      },
    ],
  }),
  methods: {
    signedOut() {
      this.$emit("signedOut");
    },
  },
};
</script>
